<template>
    <div class = "vfoot_flex">
        <div class = "vfoot_hb">
            <ul class= "vfoot_grid">
                <li>
                    <ul>
                        <span>关于济邦邦</span>
                        <li>关于我们</li>
                        <li>商务合作</li>
                        <li>在线咨询</li>
                    </ul>
                </li>
                <li style = "padding-left:85px">
                    <ul>
                        <span>财税服务</span>
                        <li>工商注册</li>
                        <li>记账报税</li>
                        <li>商标注册</li>
                    </ul>
                </li>
                <li  style = "padding-left:85px">
                    <ul>
                        <span>新手指南</span>
                        <li>新手注册</li>
                        <li>财税课堂</li>
                        <li>财税问答</li>
                    </ul>
                </li>
                <li style = "padding-left:85px;border:0;">
                    <ul class = "lastLi_flex">
                        <li>
                            <img :src="commonVal.wxPhotoUrl" alt="">
                            <span style = "width: 140px;">联系客服，请扫描二维码</span>
                        </li>
                    </ul>
                </li>
                <li style = "padding-left:85px">
                     <ul>
                         <li>
                            <img :src="commonVal.gzhPhotoUrl" alt="">
                            <span>获取更多信息，请关注公众号</span>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
        <div class = "vfoot_bd">
            <ul>
                <li>
                    <span>联系客服:</span>
                    <span class = "span_bd1">{{phoneData}}</span>
                </li>
                <li>
                    <span>售后咨询:</span>
                    <span class = "span_bd2" @click="goService()">立即咨询</span>
                </li>
                <li>
                    <span>{{commonVal.serviceTime}}</span>
                </li>
            </ul>
        </div>
        <div class = "vfoot_ft">
            <div class = "vfoot_1200">
                <ul class = "friend_a">
                    <a :href="commonVal.copyrightLink" target="_blank" >{{commonVal.copyrightDescr}}</a>
                    <span style = "margin-right:0px;">友情链接:</span>
                    <li v-for="(item,index) in linkList" :key="index">
                        <a :href="item.linkUrl" target="_blank">{{item.linkName}}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            linkList:[],
            commonVal:'',
            phoneData:'',
        }
    },
    mounted() {
        this.getLink()
        this.getCommonVal()
        this.getPhoneVal()
    },
    methods: {
        // 去客服
        goService(){
            window.open('https://dct.zoosnet.net/lr/chatpre.aspx?id=dct44015450&lng=cn&r=&rf1=&rf2=&p=https%3A//www.hzjbqy.com/tg/&cid=5d03cb84434f42888ac1e80648748afe&sid=5d03cb84434f42888ac1e80648748afe')
        },
        getLink(){
            this.$axios({
                method:'get',
                url:'/jbbcs/ow/friendshipLink/getListByCode',
                params:{
                    categoryCode:'GSZR'
                }
            }).then((res) =>{
                if(res.data.code==1){
                    this.linkList=res.data.content
                }else if(res.data.code==0){
                    this.$message.error(res.data.msg);
                }
            }).catch((error) =>{
                this.$message.error('操作失败，请重试');
            })
        },
        // 底部配置数据
        getCommonVal(){
            this.$axios({
                method:'get',
                url:'/jbbcs/owManage/cusWebConfig/getInfoByWebName',
                params:{
                    webName:'交易网站',
                }
            }).then((res) =>{
                if(res.data.code==1){
                    this.commonVal=res.data.content
                    if(this.commonVal != null){
                        if(this.commonVal.wxPhotoUrl==null){}else{
                            this.commonVal.wxPhotoUrl='https://jbbcs.hzjbqy.cn'+this.commonVal.wxPhotoUrl
                        }
                        if(this.commonVal.gzhPhotoUrl==null){}else{
                            this.commonVal.gzhPhotoUrl='https://jbbcs.hzjbqy.cn'+this.commonVal.gzhPhotoUrl
                        }
                    }
                }else if(res.data.code==0){
                    this.$message.error(res.data.msg);
                }
            }).catch((error) =>{
                this.$message.error('操作失败，请重试');
            })
        },
        // 得到电话
        getPhoneVal(){
            this.$axios({
                method:'get',
                url:'/jbbcs/owManage/cusWebConfig/getUnifiedPhone',
            }).then((res) =>{
                if(res.data.code==1){
                    this.phoneData=res.data.content
                }else if(res.data.code==0){
                    this.$message.error(res.data.msg);
                }
            }).catch((error) =>{
                this.$message.error('操作失败，请重试');
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.vfoot_flex{
    width:100%;
    color: #444546;
    background-color: #34373a;
    .vfoot_hb{
        width:100%;
        padding: 40px 0;
        display: block;
        border-bottom: 1px solid #3e4144;
        .vfoot_grid{
            width: 1200px;
            margin: 0 auto;
            height: 165px;
            >li{
                display: inline-block;
                float: left;
                width: 110px;
                height: 165px;
                padding-right: 60px;
                text-align: left;
                margin: 0;
                border-right: 1px solid #3e4144;
                ul{
                    >span{
                        font-size: 18px;
                        font-weight: 400;
                        margin-bottom: 5px;
                        color: #fff;
                        line-height: 27px;
                        display: inline-block;
                    }
                    li{
                        font-size:14px;
                        line-height: 32px;
                        color:#707274;
                        cursor: pointer;
                        img{
                            display: block;
                            width: 140px;
                            height: 140px;
                        }
                        >span{
                            display: block;
                            width: 156px;
                            color: #707274;
                            padding-top: 10px;
                            font-size: 12px;
                            text-align: center;
                        }
                    }
                    >li:hover{
                        text-decoration: none;
                        color: #e10f30;
                        line-height:32px;
                    }
                }
            }
        }
    }
    .vfoot_bd{
        height:90px;
        line-height:90px;
        color:#707274;
        width: 1200px;
        margin: 0 auto;
        font-size: 14px;
        >ul{ 
            float: left;
            li{
                display: inline-block;  
                .span_bd1{
                    margin-right: 25px;
                    font-size: 24px;
                    font-weight: 700;
                    font-family: Arial;
                    color: #fff;
                    margin-left:3px;
                }
                .span_bd2{
                    margin-right: 50px;
                    display: inline-block;
                    margin-left:3px;
                    width: 145px;
                    height: 33px;
                    line-height: 33px;
                    border-radius: 4px;
                    text-align: center;
                    color: #e10f30;
                    background-color: #fff;
                    cursor: pointer;
                }
                .span_bd2:hover{
                    background-color: #e10f30;
                    color: #fff;
                }
            }
        }
    }
    .vfoot_ft{
        height: 50px;
        line-height: 50px;
        font-size: 13px;
        background-color: #242527;
        .vfoot_1200{
            width:1200px;
            margin:0 auto;
            .friend_a{
                float: left;
                >span{
                    color:rgba(255,255,255,.5);
                    font-family:"microsoft yahei";
                    margin-right:50px;
                }
                >a{
                    color:rgba(255,255,255,.5);
                    font-family:"microsoft yahei";
                    margin-right:50px;
                }
                >li{
                    display: inline-block;
                    color:#707274;
                    font-size:13px;
                    margin-left:12px;
                    cursor: pointer;
                    a{
                        color:#707274;
                    }
                }
                >li:hover a{
                    border-bottom:1px solid #707274;
                }
            }
        }
    }
}
</style>





// WEBPACK FOOTER //
// src/components/common/vfoot.vue